import React, { useState, useEffect } from "react";
import "./Navigation.css";

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "Home", href: "#hero" },
    { name: "About", href: "#about" },
    { name: "Skills", href: "#skills" },
    { name: "Projects", href: "#projects" },
    { name: "Contact", href: "#contact" },
  ];

  const handleNavClick = (event, href) => {
    event.preventDefault();
    setIsOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <nav className={`navigation ${isScrolled ? "scrolled" : ""}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <a href="#hero" onClick={(event) => handleNavClick(event, "#hero")}>
            ./ghali_faiçal.sh
          </a>
        </div>
        <ul className={`nav-links ${isOpen ? "open" : ""}`}>
          {navItems.map((item, index) => (
            <li key={item.name}>
              <a
                href={item.href}
                onClick={(event) => handleNavClick(event, item.href)}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ul>
        <button className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "✕" : "☰"}
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
